uniform float uTime;
uniform sampler2D uPerlinTexture;

varying vec2 vUv;

void main()
{
    vec2 perlinUv = uv;
    vec4 perlin = texture(uPerlinTexture, perlinUv);

    vec4 modelPosition = modelMatrix * vec4(position, 1.0);
    float distanceFromEdge = distance(uv, vec2(1.0, uv.y));
    // modelPosition.y += 0.1 * distanceFromEdge * sin(-16.0 * distanceFromEdge + (0.5 * uTime)) + (0.1 * perlin.x);
    modelPosition.y += 0.03 * sin(0.5 * uTime) + 0.02;
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectionPosition = projectionMatrix * viewPosition;

    gl_Position = projectionPosition;

    vUv = uv;
}